import { useState } from 'react';
import { Router } from 'routes';
import { SplashScreen } from 'components/SplashScreen';

export function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && <SplashScreen duration={3000} onFinish={() => setShowSplash(false)} />}
      <Router />
    </>
  );
}
